"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _Folder = _interopRequireDefault(require("@mui/icons-material/Folder"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const FileStats = props => {
  const {
    uploadSuccess,
    show,
    fileName,
    fileSize,
    fileDownloadURL,
    error
  } = props;
  const classes = (0, _styles.useStyles)();
  if (!show) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.imgUploaderContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.uploadDetails
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: uploadSuccess ? classes.successfullUpload : classes.uploadStatusContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: error ? classes.errorField : classes.uploadStatusContainer
  }, /*#__PURE__*/_react.default.createElement(_Folder.default, null), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: uploadSuccess ? classes.uploaded : classes.uploadStatus
  }, uploadSuccess ? "Files Uploaded Successfully" : "No/Wrong Files Uploaded"))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.title
  }, "File Name:"), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.value
  }, fileName)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.title
  }, "Size:"), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.value
  }, fileSize)), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.uploadBtns
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: fileDownloadURL,
    download: true,
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    children: "download files",
    color: "primary",
    variant: "text",
    disabled: !uploadSuccess
  })), " ")));
};
FileStats.prototypes = {
  show: _propTypes.default.bool,
  uploadSuccess: _propTypes.default.func,
  fileName: _propTypes.default.func,
  fileSize: _propTypes.default.number,
  fileDownloadURL: _propTypes.default.string
};
var _default = exports.default = FileStats;